import { Pipe, PipeTransform } from '@angular/core';

enum FUNDING_METHODS {
	WIRE_TRANSFER = 'Wire Transfer',
	BRANCH_DEPOSIT = 'Branch Deposit',
	CASHIER_CHECK = 'Cashier Check',
	NONE = 'None',
}

@Pipe({
	name: 'fundingMethod',
	standalone: true,
})
export class FundingMethodPipe implements PipeTransform {
	transform(value: string): string {
		return FUNDING_METHODS[value];
	}
}
